import { BaseModel } from "model/BaseModel";
import Estagio from "./Estagio";
import OrdemProducao from "./OrdemProducao";
import ComponenteOP from "./ComponenteOP";
import ExecucaoPlanoQualidade from "model/qualidade/ExecucaoPlanoQualidade";

export default class EstagioOP implements BaseModel {
    id: number;
    codigo: string | null = "";
	sequencial: number;
	sequencialPosicionamento: number;
	dataHoraInicio: Date;
	dataHoraFim: Date;
	status: string;
	ordemProducao: OrdemProducao;
	estagio: Estagio;
    execucaoPlanoQualidade: ExecucaoPlanoQualidade;
    componentes: ComponenteOP[];
    componentesAcerto: ComponenteOP[];
    temAcerto: string;
    estagioFinal: boolean;

    constructor(
        id: number = 0,
        sequencial: number = 0,
        sequencialPosicionamento: number = 0,
        dataHoraInicio: Date = new Date(),
        dataHoraFim: Date = new Date(),
        status: string = "",
        ordemProducao: OrdemProducao = new OrdemProducao(),
        estagio: Estagio = new Estagio(),
        execucaoPlanoQualidade: ExecucaoPlanoQualidade = new ExecucaoPlanoQualidade(),
        componentes: ComponenteOP[] = [],
        componentesAcerto: ComponenteOP[] = [],
        temAcerto: string = "N",
        estagioFinal: boolean = false
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.sequencialPosicionamento = sequencialPosicionamento;
        this.dataHoraInicio = dataHoraInicio;
        this.dataHoraFim = dataHoraFim;
        this.status = status;
        this.ordemProducao = ordemProducao;
        this.estagio = estagio;
        this.execucaoPlanoQualidade = execucaoPlanoQualidade;
        this.componentes = componentes;
        this.componentesAcerto = componentesAcerto;
        this.temAcerto = temAcerto;
        this.estagioFinal = estagioFinal;
    }

}